import { getRequest, postRequest, patchRequest, patchMultipartRequest } from './api';

const googleApi = {
  // --- Google Ads ---
  async connectGoogleAds() {
    return getRequest('/google-ads/connect');
  },

  async fetchGoogleAdsAccounts(force = false) {
    return getRequest('/google-ads/accounts', {}, { force });
  },

  async fetchActiveGoogleAccount() {
    return getRequest('/google-ads/active-account');
  },  

  async setActiveGoogleAdsAccount(google_customer_id) {
    const response = await postRequest('/google-ads/set-active-account', { google_customer_id });
    return response.data;
  },

  async disconnectGoogleAds() {
    const response = await postRequest('/google-ads/disconnect', {});
    return response.data;
  },

  async fetchGoogleAdsCampaigns(params) {
    return getRequest('/google-ads/campaigns', {}, params);
  },

  async fetchGoogleAdsUserInfo() {
    return getRequest('/google-ads/userinfo');
  },

  async fetchUserGoogleAdsCampaigns(id, params) {
    return getRequest(`/admin/campaigns/google/${id}`, {}, params);
  },

  async fetchGoogleAdsCampaignById(campaignId) {
    return getRequest(`/google-ads/campaigns/${campaignId}`);
  },

  async fetchUserGoogleAdsCampaignById(id, campaignId, params = {}) {
    return getRequest(`/admin/campaigns/google/${id}/${campaignId}`, {}, params);
  },

  async fetchGoogleAnalyticsData(start_date, end_date) {
    return getRequest('/api/google-ads', {}, { start_date, end_date });
  },

  async updateGoogleAdsCampaign(campaignId, { payload, isMultipart }) {
    if (isMultipart) {
      const response = await patchMultipartRequest(`/google-ads/campaigns/${campaignId}`, payload);
      return response.data;
    } else {
      const response = await patchRequest(`/google-ads/campaigns/${campaignId}`, payload);
      return response.data;
    }
  }  
  
};

export default googleApi;
